/* Tattup Help Center — live search, deep links, scrollspy (sections/thc-help-center.liquid) */
(() => {
  if (window.__thcLoaded) return;
  window.__thcLoaded = true;

  // Small synonym table so common wordings find the right answers (keys and values are normalized).
  const SYNONYMS = {
    haltbarkeit: ['haltbar', 'halt', 'verblass', 'wochen'],
    halten: ['halt', 'verblass', 'wochen'],
    anwendung: ['anbring', 'auftrag', 'anwend'],
    auftragen: ['anbring', 'auftrag'],
    ruckgabe: ['ruckgabe', 'ruckerstatt', 'widerruf', 'zuruck'],
    retoure: ['ruckgabe', 'ruckerstatt', 'widerruf'],
    kosten: ['kost', 'versand', 'preis', 'chf'],
    lieferzeit: ['lieferzeit', 'werktag', 'versand'],
    allergie: ['allerg', 'reaktion', 'reizung'],
    refund: ['refund', 'return', 'withdraw'],
    return: ['return', 'refund'],
    last: ['last', 'fade', 'week'],
    apply: ['apply', 'applic'],
    delivery: ['deliver', 'shipping'],
    allergy: ['allerg', 'reaction', 'irritat'],
    ki: ['ki', 'ai'],
    ai: ['ai', 'ki'],
    token: ['token', 'credit'],
    tokens: ['token', 'credit'],
    gratis: ['gratis', 'kostenlos', 'free'],
    kostenlos: ['kostenlos', 'gratis'],
    free: ['free', 'gratis'],
    extrahieren: ['extrah', 'extract'],
    extract: ['extract', 'extrah'],
    abo: ['abo', 'subscription'],
    abonnement: ['abo', 'subscription'],
    subscription: ['subscription', 'abo'],
    nachkaufen: ['nachkauf', 'kauf', 'credit']
  };
  // Short words that only count as a whole word ("ki" must not match "skin", "ai" not "again").
  const WHOLE_WORDS = new Set(['ki', 'ai']);

  const normalize = (s) =>
    (s || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const fmt = (tpl, vars) => (tpl || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const escapeHtml = (s) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  function track(query, results) {
    const detail = { query, results, page: location.pathname };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('help_center_search', detail);
        if (results === 0) Shopify.analytics.publish('help_center_search_no_results', detail);
      }
    } catch (e) {}
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: results === 0 ? 'help_center_search_no_results' : 'help_center_search', help_center_query: query, help_center_results: results });
    }
  }

  function openItem(el, flash) {
    if (!el) return;
    el.open = true;
    if (flash) {
      el.classList.remove('is-flash');
      void el.offsetWidth;
      el.classList.add('is-flash');
    }
  }

  function init(root) {
    const mode = root.dataset.mode;
    const input = root.querySelector('[data-thc-input]');
    const form = root.querySelector('[data-thc-form]');
    const clearBtn = root.querySelector('[data-thc-clear]');
    const status = root.querySelector('[data-thc-status]');
    const ask = root.querySelector('[data-thc-ask]');
    const askBody = root.querySelector('[data-thc-ask-body]');
    const askDone = ask && ask.querySelector('[data-thc-ask-done]');
    const browse = root.querySelectorAll('[data-thc-browse]');
    const groups = [...root.querySelectorAll('[data-thc-group]')];
    const items = [...root.querySelectorAll('[data-thc-item]')].map((el) => {
      const q = el.querySelector('[data-thc-q]');
      const a = el.querySelector('[data-thc-a]');
      return { el, q, qHtml: q.innerHTML, qNorm: normalize(q.textContent), aNorm: normalize(a ? a.textContent : '') };
    });
    if (!input) return;

    let lastTracked = '';
    let trackTimer = null;

    const tokenize = (query) =>
      normalize(query)
        .split(' ')
        .filter((t) => t.length > 1)
        .map((t) => [t, ...(SYNONYMS[t] || [])]);

    function highlight(item, tokens) {
      if (!tokens.length) {
        item.q.innerHTML = item.qHtml;
        return;
      }
      // Matching uses normalized text; on the visible text, match each typed word accent-insensitively.
      const words = tokens.map((alts) => alts[0]).filter(Boolean);
      let html = escapeHtml(item.q.textContent);
      words.forEach((w) => {
        let pattern = w
          .split('')
          .map((ch) => ({ a: '[aäàá]', o: '[oöòó]', u: '[uüùú]', e: '[eéèê]', s: '(?:ss|ß|s)' })[ch] || escapeRe(ch))
          .join('');
        if (WHOLE_WORDS.has(w)) pattern = `(?<![\\p{L}\\p{N}])${pattern}(?![\\p{L}\\p{N}])`;
        html = html.replace(new RegExp(`(${pattern})`, 'giu'), '<mark>$1</mark>');
      });
      item.q.innerHTML = html;
    }

    function setStatus(query, count) {
      if (!status) return;
      if (!query) {
        status.hidden = true;
        status.innerHTML = '';
        return;
      }
      const q = escapeHtml(query);
      const title = count === 0 ? fmt(root.dataset.tNoResults, { query: q }) : fmt(count === 1 ? root.dataset.tResultsOne : root.dataset.tResultsOther, { query: q, count });
      let html = `<p class="thc-status__count">${title}</p>`;
      if (count === 0 && (!ask || askDone)) {
        const hint = root.querySelector('.thc-contact__text');
        if (hint) html += `<p class="thc-status__hint">${escapeHtml(hint.textContent)}</p>`;
      }
      if (mode === 'category') {
        const url = `${root.dataset.hubUrl}?q=${encodeURIComponent(query)}`;
        html += `<a class="thc-status__link" href="${url}">${escapeHtml(root.dataset.tSearchAll)} →</a>`;
      }
      status.innerHTML = html;
      status.hidden = false;
    }

    // "Ask us" form for searches without results (Shopify contact form), prefilled with the search text.
    function toggleAsk(query, count) {
      if (!ask || askDone) return;
      const show = !!query && count === 0;
      ask.hidden = !show;
      if (show && askBody && (!askBody.value || askBody.dataset.auto === '1')) {
        askBody.value = query;
        askBody.dataset.auto = '1';
      }
    }
    if (askBody) askBody.addEventListener('input', () => (askBody.dataset.auto = '0'));

    function run(query, { fromUser = true } = {}) {
      const trimmed = query.trim();
      const tokens = tokenize(trimmed);
      clearBtn.hidden = !trimmed;
      let count = 0;

      items.forEach((item) => {
        const hay = ' ' + item.qNorm + ' ' + item.aNorm + ' ';
        const match =
          !tokens.length ||
          tokens.every((alts) => alts.some((t) => hay.includes(WHOLE_WORDS.has(t) ? ` ${t} ` : t)));
        item.el.hidden = !match;
        highlight(item, match ? tokens : []);
        if (match) count++;
      });
      groups.forEach((g) => {
        g.hidden = !!tokens.length && !g.querySelector('[data-thc-item]:not([hidden])');
      });
      browse.forEach((b) => (b.hidden = !!tokens.length));
      setStatus(tokens.length ? trimmed : '', count);
      toggleAsk(tokens.length ? trimmed : '', count);

      if (tokens.length && count > 0 && count <= 3) items.filter((i) => !i.el.hidden).forEach((i) => openItem(i.el));

      if (mode === 'hub') {
        const url = new URL(location.href);
        if (tokens.length) url.searchParams.set('q', trimmed);
        else url.searchParams.delete('q');
        history.replaceState(history.state, '', url);
      }

      clearTimeout(trackTimer);
      if (fromUser && trimmed.length >= 3) {
        trackTimer = setTimeout(() => {
          if (trimmed !== lastTracked) {
            lastTracked = trimmed;
            track(trimmed, count);
          }
        }, 1200);
      }
    }

    input.addEventListener('input', () => run(input.value));
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        input.value = '';
        run('');
      }
    });
    form.addEventListener('submit', (e) => {
      if (mode === 'hub') {
        e.preventDefault();
        input.blur();
        if (status && !status.hidden) status.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    clearBtn.addEventListener('click', () => {
      input.value = '';
      run('');
      input.focus();
    });
    root.querySelectorAll('[data-thc-term]').forEach((chip) =>
      chip.addEventListener('click', () => {
        input.value = chip.dataset.thcTerm;
        run(input.value);
        if (status) status.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );

    // Copy deep link to a question.
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-thc-copy]');
      if (!btn) return;
      const url = `${location.origin}${location.pathname}#${btn.dataset.thcCopy}`;
      const label = btn.querySelector('span');
      const done = () => {
        btn.classList.add('is-done');
        if (label) label.textContent = root.dataset.tCopied;
        setTimeout(() => {
          btn.classList.remove('is-done');
          if (label) label.textContent = root.dataset.tCopy;
        }, 2000);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, () => {});
      history.replaceState(history.state, '', `#${btn.dataset.thcCopy}`);
    });

    // Jump links ("most asked") and incoming #hash links open the matching answer.
    const openFromHash = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      const el = document.getElementById(id);
      if (el && el.matches('[data-thc-item]')) {
        if (el.hidden) {
          input.value = '';
          run('', { fromUser: false });
        }
        openItem(el, true);
        requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
    };
    window.addEventListener('hashchange', openFromHash);
    root.querySelectorAll('[data-thc-open]').forEach((a) =>
      a.addEventListener('click', () => setTimeout(openFromHash, 0))
    );

    // Topic navigation on the hub: an active search hides other topics, so clear it before jumping.
    const spyLinks = [...root.querySelectorAll('[data-thc-spy]')];
    spyLinks.forEach((link) =>
      link.addEventListener('click', (e) => {
        const target = document.getElementById(link.dataset.thcSpy);
        if (!target) return;
        e.preventDefault();
        if (input.value.trim()) {
          input.value = '';
          run('', { fromUser: false });
        }
        // The site header comes back while scrolling up and hides while scrolling down (theme behaviour):
        // keep the topic title clear of it in both directions.
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height')) || 180;
        const top = target.getBoundingClientRect().top + window.scrollY;
        const offset = (top < window.scrollY ? headerHeight : 0) + 74;
        window.scrollTo({ top: Math.max(0, top - offset), behavior: 'smooth' });
        history.replaceState(history.state, '', `#${link.dataset.thcSpy}`);
      })
    );

    // Scrollspy for the topic navigation on the hub.
    if (spyLinks.length && 'IntersectionObserver' in window) {
      const byId = new Map(spyLinks.map((l) => [l.dataset.thcSpy, l]));
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            spyLinks.forEach((l) => l.classList.remove('is-active'));
            const link = byId.get(en.target.id);
            if (link) link.classList.add('is-active');
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      groups.forEach((g) => io.observe(g));
    }

    // After submitting the "ask us" form Shopify reloads the page: show the confirmation or errors.
    if (askDone) {
      ask.hidden = false;
      requestAnimationFrame(() => ask.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }

    // Initial state from ?q= and #hash.
    const initial = new URLSearchParams(location.search).get('q');
    if (initial) {
      input.value = initial;
      run(initial, { fromUser: false });
    }
    openFromHash();
  }

  // "/" focuses the help center search from anywhere on the page.
  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
    const t = e.target;
    if (t && (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName))) return;
    const input = document.querySelector('[data-thc] [data-thc-input]');
    if (input) {
      e.preventDefault();
      input.focus();
    }
  });

  const boot = () => document.querySelectorAll('[data-thc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-thc]');
    if (root) init(root);
  });
})();
